import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { useState, useEffect } from 'react'
import { DgaIcon } from 'platformscode-new-react'
const ehsanLogo = "/assets2/imges/Ehsan.svg";
import './MainLayout.css'

function MainLayout() {
  const [isViewGreyscale, setIsViewGreyscale] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const toggleViewMode = () => {
    setIsViewGreyscale(prev => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 560);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="wrapper">

    
      <Header toggleViewMode={toggleViewMode} isViewGreyscale={isViewGreyscale} />

      <main
        id="main-content"
        tabIndex={-1}
        className={`c-ontent ${isViewGreyscale ? 'greyscale' : ''}`}
      >
        <Outlet />
      </main>

      <div role="contentinfo" className={isViewGreyscale ? 'greyscale' : ''}>
        <Footer toggleViewMode={toggleViewMode} isViewGreyscale={isViewGreyscale} />
      </div>

      {/* إحسان floating button — always visible */}
      <a
        href="https://ehsan.sa"
        target="_blank"
        rel="noopener noreferrer"
        className="ehsan-float-btn"
        aria-label="تبرع عبر منصة إحسان"
      >
        <img src={ehsanLogo} alt="إحسان" width={32} height={32} />
      </a>

      {/* Scroll to top button — appears after scrolling past the slider */}
      <button
        type="button"
        className={`scroll-top-btn${showScrollTop ? ' visible' : ''}`}
        onClick={scrollToTop}
        aria-label="العودة إلى أعلى الصفحة"
      >
        <DgaIcon aria-hidden="true" icon="arrow-up-01" size={22} color="#fff" type="rounded" variant="stroke" />
      </button>



    </div>
  )
}

export default MainLayout;
